import React from 'react';
import { ButtonGroupStyle, ButtonMode, ButtonSize, ButtonVariant } from './Button';
import styles from './ButtonGroup.module.scss';

export const ButtonGroup: React.FC<{
    size?: ButtonSize;
    borderColour?: string;
    mode?: ButtonMode;
    variant?: ButtonVariant;
}> = props => {
    const { children, ...otherProps } = props;
    if (React.Children.count(children) === 0) return null;

    if (React.Children.toArray(children).filter(Boolean).length === 1)
        return React.cloneElement(React.Children.toArray(children).filter(Boolean)[0] as React.ReactElement, {
            ...otherProps
        });

    const childrenArray = React.Children.toArray(children);
    const firstChild = childrenArray.slice(0, 1);
    const rest = childrenArray.slice(1, childrenArray.length - 1);
    const lastChild = childrenArray.slice(-1);

    return (
        <div className={styles.container}>
            {React.Children.map(firstChild, child =>
                React.cloneElement(child as React.ReactElement, {
                    buttonGroup: ButtonGroupStyle.Left,
                    ...otherProps
                })
            )}
            {React.Children.map(rest, child =>
                React.cloneElement(child as React.ReactElement, {
                    buttonGroup: ButtonGroupStyle.Center,
                    ...otherProps
                })
            )}
            {React.Children.map(lastChild, child =>
                React.cloneElement(child as React.ReactElement, {
                    buttonGroup: ButtonGroupStyle.Right,
                    ...otherProps
                })
            )}
        </div>
    );
};
